import DropdownHelper from "../../../../Assets/JavaScripts/Project/Modules/Dropdown";
import { webkitLineClamp } from 'webkit-line-clamp';

/**
 * Update the height of the navigation
 */
export function updateHeightOfNavigation() {
    const navigation = document.querySelector('#header-navigation');
    if (navigation) {
        const navigationHeight = navigation.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--header-navigation-height', `${navigationHeight}px`);
    }

    const headerMainNavigation = document.querySelector('.header-controls');
    if (headerMainNavigation) {
        document.documentElement.style.setProperty('--header-main-container-bottom', `${headerMainNavigation.clientHeight}px`);
    }

    const headerSearch = document.querySelectorAll('.header-search');
    if (headerSearch) {
        headerSearch.forEach((search: HTMLElement) => {
            search.style.setProperty('--header-search-width', `${search.clientWidth}px`);
        });
    }
}

/**
 * Initialization for the menu
 */
export function initMainMenu() {
    /**
     * Get the target of the button
     *
     * @param button
     */
    const getTargetOfButton = (button: HTMLElement) => {
        const targetSelector = button.dataset.plandentTarget;

        if (!targetSelector) {
            return null;
        }

        return document.querySelector(targetSelector) as HTMLElement;
    }

    /**
     * Hide all main menu items
     */
    const methodHideAll = () => {
        const toggleItems = document.querySelectorAll('[data-plandent-toggle="mainMenu"]') as NodeListOf<HTMLElement>;

        toggleItems.forEach((toggleBtn) => {
            getTargetOfButton(toggleBtn)?.classList.remove('show');
        });
    }

    /**
     * Toggle the menu
     *
     * @param method
     */
    const toggleMenu = (method: string|null = null) => {
        const headerNavigation = document.querySelector('#header-navigation-menu') as HTMLElement;
        let headerToggledEvent = null;

        if (!headerNavigation) {
            return;
        }

        switch (method) {
            case 'hide':
                headerNavigation.classList.remove('show');
                methodHideAll();
                document.querySelectorAll('[aria-controls="#header-navigation-menu"][data-plandent-action="mainMenu"]').forEach((button) => {
                    button.classList.remove('is-active');
                });
                headerToggledEvent = new Event('plandent.headernavigation.hide');
                document.dispatchEvent(headerToggledEvent);
                break;
            case 'show':
                headerNavigation.classList.add('show');
                document.querySelectorAll('[aria-controls="#header-navigation-menu"][data-plandent-action="mainMenu"]').forEach((button) => {
                    button.classList.add('is-active');
                });
                headerToggledEvent = new Event('plandent.headernavigation.show');
                document.dispatchEvent(headerToggledEvent);
                break;
            default:


                headerNavigation.classList.toggle('show');

                if (!headerNavigation.classList.contains('show')) {
                    methodHideAll();
                    headerToggledEvent = new Event('plandent.headernavigation.hide');
                } else {
                    headerToggledEvent = new Event('plandent.headernavigation.show');
                }

                document.dispatchEvent(headerToggledEvent);

                document.querySelectorAll('[aria-controls="#header-navigation-menu"][data-plandent-action="mainMenu"]').forEach((button) => {
                    if (!headerNavigation.classList.contains('show')) {
                        button.classList.remove('is-active');
                    } else {
                        button.classList.add('is-active');
                    }
                });
        }
    }

    /**
     * Toggle the target or show/hide it
     *
     * @param toggleBtn
     * @param method
     */
    const toggleTheTarget = (toggleBtn: HTMLElement, method: string|null = null) => {
        switch (method) {
            case 'hide':
                getTargetOfButton(toggleBtn)?.classList.remove('show');
                break;
            case 'show':
                getTargetOfButton(toggleBtn)?.classList.add('show');
                break;
            default:
                // hide all other menus
                const otherMenus = document.querySelectorAll('.main-menu-item-body[data-main-menu-level]') as NodeListOf<HTMLElement>;

                otherMenus.forEach((menu) => {
                    // hide all because we are on the top level
                    if (menu.dataset.mainMenuLevel === "0") {
                        // check that menu is not a parent of the target
                        if (!menu.contains(getTargetOfButton(toggleBtn))) {
                            menu.classList.remove('show');

                            const menusInside = menu.querySelectorAll('.main-menu-item-body[data-main-menu-level]') as NodeListOf<HTMLElement>;

                            menusInside.forEach((menuInside) => {
                                menuInside.classList.remove('show');
                            });
                        }
                    }
                });

                getTargetOfButton(toggleBtn)?.classList.toggle('show');
                break;
        }
    }

    const isOpen = (toggleBtn: HTMLElement) => {
        return getTargetOfButton(toggleBtn)?.classList.contains('show') ?? false;
    }

    /**
     * Initialize the toggle items
     */
    const initToggleItems = () => {
        const toggleItems = document.querySelectorAll('[data-plandent-toggle="mainMenu"]') as NodeListOf<HTMLElement>;

        toggleItems.forEach((toggleBtn) => {
            toggleBtn.addEventListener('click', toggleTheTarget.bind(null, toggleBtn, toggleBtn.dataset.plandentMethod ?? null), {passive: true});
        }, {passive: true});
    }

    /**
     * Initialize the actions
     */
    const initActions = () => {
        const actionItems = document.querySelectorAll('[data-plandent-action="mainMenu"]') as NodeListOf<HTMLElement>;

        actionItems.forEach((actionItem) => {
            actionItem.addEventListener('click', () => {
                const method = actionItem.dataset.plandentMethod ?? null;

                if (!method) {
                    return;
                }

                switch (method) {
                    case 'hideAll':
                        methodHideAll();
                        break;
                    case 'collapseMobile':
                        toggleMenu();
                        break;
                }
            }, {passive: true});
        });

        document.querySelector('body')?.addEventListener('click', (e) => {
            if (document.querySelector('.main-menu-item-body.show')) {
                const target = (e.target as HTMLElement).closest('#header-navigation-menu');
                if (!target) {
                    methodHideAll();
                }
            }
        });
    }

    const cropLines = () => {
        const croppedLines = document.querySelectorAll('#header-navigation-menu .croppedLines') as NodeListOf<HTMLElement>;
        croppedLines.forEach((croppedLine) => {
            const lines = parseInt(croppedLine.dataset.linecrop ?? '1', 10);

            webkitLineClamp(croppedLine, lines);
        });
    }

    window.addEventListener('scroll', () => {
        updateHeightOfNavigation();
    }, {passive: true});

    window.addEventListener('resize', () => {
        updateHeightOfNavigation();
        cropLines();

        const customerServiceMenuMobile = document.querySelector('.header-customer-service--mobile button[data-plandent-target="#mainNav_contact"]') as HTMLElement;
        const customerServiceDesktopDropdown = document.querySelector('.header-customer-service--desktop button[data-bs-toggle="dropdown"]') as HTMLElement;

        // collapse the mobile menu if no item is open
        if (document.querySelector('.main-menu-item-body.show') === null && window.Viewport.mediaBreakpointDown('lg')) {
            toggleMenu('hide');
        }

        if (!customerServiceMenuMobile || !customerServiceDesktopDropdown) {
            return;
        }

        const dropdown = DropdownHelper.getOrCreateInstance(customerServiceDesktopDropdown);

        if (isOpen(customerServiceMenuMobile) && window.Viewport.mediaBreakpointUp('lg')) {
            toggleTheTarget(customerServiceMenuMobile, 'hide');
            dropdown.show();
        }

        if(dropdown.getDropdownElement().classList.contains('show') && window.Viewport.mediaBreakpointDown('lg')) {
            dropdown.hide();
            toggleMenu('show');

            toggleTheTarget(customerServiceMenuMobile, 'show');
        }
    })

    initToggleItems();
    initActions();
    updateHeightOfNavigation();
    cropLines();
}
